export default "__VITE_ASSET__rPmQC$Fk__"